export const REALMS = {
  EVBASIC: "evbasic",
  EVCORE: "evcore",
};

export const OIDC_CLIENT_ID = "ev-candidate";

export const PROCESS = {
  ProcessStatus: {
    DRAFT: {
      Name: "DRAFT",
    },
    LAUNCHED: {
      Name: "LAUNCHED",
    },
    CLOSED: {
      Name: "CLOSED",
    },
    CANCELED: {
      Name: "CANCELED",
    },
  },
  ProcessPersonStatus: {
    OPEN: {
      Name: "OPEN",
    },
    INPROGRESS: {
      Name: "INPROGRESS",
    },
    ENDED: {
      Name: "ENDED",
    },
    DISQUALIFIED: {
      Name: "DISQUALIFIED",
    },
  },
  ProcessPaymentType: {
    CLIENT: {
      Name: "CLIENT",
    },
    EVALUATED: {
      Name: "EVALUATED",
    },
    BOTH: {
      Name: "BOTH",
    },
    DEFERRED_EVALUATED: {
      Name: "DEFERRED_EVALUATED",
    },
    FREEMIUM: {
      Name: "FREEMIUM",
    },
  },
  TypeCompanyPlan: {
    POTENTIAL: {
      Name: "POTENTIAL",
    },
  },
  ProcessReportSource: {
    FEEDBACK: {
      Name: "feedback",
    },
    POTENTIAL: {
      Name: "POTENTIAL",
    },
  },
  ProcessReportVendor: {
    FEEDBACK: {
      Name: "feedback",
    },
    POTENTIAL: {
      Name: "feedback-potential",
    },
  },
};
